import { SORT_INCIDENTS } from "./incidentActionTypes";

import _ from "lodash";
export default (state = {}, action) => {
  switch (action.type) {
    case SORT_INCIDENTS:
      return action.sort;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/incidents/sortIncidentReducer.js